import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { BookOpen, Heart, Users, Globe } from 'lucide-react';

const About = () => {
  return (
    <div className="min-h-screen bg-background-primary">
      <Navbar />

      {/* Banner */}
      <section className="bg-brand-primary py-20" data-testid="about-banner">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
          <h1 className="font-heading text-4xl md:text-5xl font-semibold tracking-tighter text-white mb-6">
            About Restore My Word
          </h1>
          <p className="font-body text-lg text-white/90">
            Sharing God's Word with the world, one resource at a time.
          </p>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-24 md:py-32">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          {/* Mission */}
          <div className="text-center mb-16">
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-brand-accent mb-4 block">
              OUR MISSION
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-medium tracking-tight text-brand-primary mb-6">
              Empowering the Next Generation
            </h2>
            <p className="font-body text-lg leading-relaxed text-slate-700">
              To empower Gen Zers ages 10–20 to become mighty men and women of faith who stand against the evil of 
              this generation and help restore God's truth, love, and holiness. Through God's anointing, we share 
              Bible-based stories that reveal His reality, power, grace, and transforming love—encouraging young hearts 
              to grow deeper in Christ and boldly live out their faith in today's world.
            </p>
          </div>

          {/* Vision */}
          <div className="text-center mb-16">
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-brand-accent mb-4 block">
              OUR VISION
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-medium tracking-tight text-brand-primary mb-6">
              A Generation Rooted in God's Word
            </h2>
            <p className="font-body text-lg leading-relaxed text-slate-700">
              A generation of young people firmly rooted in God's Word, inspired to live with faith, purpose, kindness, 
              wisdom, and courage—shining as lights in today's world and leading others toward Christ through their 
              lives and testimony.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white border border-slate-200 rounded shadow-sm p-8">
              <div className="w-12 h-12 bg-brand-accent/10 rounded-full flex items-center justify-center mb-4">
                <BookOpen className="h-6 w-6 text-brand-accent" />
              </div>
              <h3 className="font-heading text-xl font-medium text-brand-primary mb-3">
                Free Resources
              </h3>
              <p className="font-body text-base text-slate-700">
                All our resources are completely free. We believe God's Word should never be behind a paywall.
              </p>
            </div>

            <div className="bg-white border border-slate-200 rounded shadow-sm p-8">
              <div className="w-12 h-12 bg-brand-accent/10 rounded-full flex items-center justify-center mb-4">
                <Heart className="h-6 w-6 text-brand-accent" />
              </div>
              <h3 className="font-heading text-xl font-medium text-brand-primary mb-3">
                Faith-Centered
              </h3>
              <p className="font-body text-base text-slate-700">
                Every resource is carefully curated to honor Scripture and build faith in Jesus Christ.
              </p>
            </div>

            <div className="bg-white border border-slate-200 rounded shadow-sm p-8">
              <div className="w-12 h-12 bg-brand-accent/10 rounded-full flex items-center justify-center mb-4">
                <Users className="h-6 w-6 text-brand-accent" />
              </div>
              <h3 className="font-heading text-xl font-medium text-brand-primary mb-3">
                Community Driven
              </h3>
              <p className="font-body text-base text-slate-700">
                Built by believers, for believers. We're a community united in sharing God's truth.
              </p>
            </div>

            <div className="bg-white border border-slate-200 rounded shadow-sm p-8">
              <div className="w-12 h-12 bg-brand-accent/10 rounded-full flex items-center justify-center mb-4">
                <Globe className="h-6 w-6 text-brand-accent" />
              </div>
              <h3 className="font-heading text-xl font-medium text-brand-primary mb-3">
                Global Reach
              </h3>
              <p className="font-body text-base text-slate-700">
                Our digital resources reach people around the world, breaking down barriers to access.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-24 md:py-32 bg-background-tertiary">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <h2 className="font-heading text-3xl md:text-4xl font-medium tracking-tight text-brand-primary mb-6 text-center">
            Our Story
          </h2>
          <div className="space-y-6 font-body text-base leading-relaxed text-slate-700">
            <p>
              Restore My Word was founded on a simple conviction: God's Word should be freely available to all people, 
              in all formats, for all generations. In an increasingly digital world, we saw an opportunity to preserve 
              and share biblical teachings in new and accessible ways.
            </p>
            <p>
              What started as a small collection of audio teachings has grown into a comprehensive digital library 
              featuring stories, audio recordings, videos, and downloadable resources. Each piece of content is 
              carefully created or curated to honor the truth of Scripture and build faith in Jesus Christ.
            </p>
            <p>
              Today, we serve thousands of believers around the world who are hungry for God's Word. Whether you're 
              looking for a devotional reading, an audio teaching for your commute, or a video study for your small 
              group, our prayer is that these resources will strengthen your faith and draw you closer to Jesus.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default About;